<div class="cald_dialog construct-list-tag-dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{headerTranslationKey | translate}}</h2>
  </div>
  <div class="cald_content ctx-formula-builder-content page-content-wrapper">
    <div class="ctx-help">
      <span>{{'Admin.Msg.Help' | translate}}</span>
      <a href="https://help.sap.com/docs/SAP_CPQ/884885f05e6b4c8082254d4d9d63f19b/f119846f098747c0a5afca3f0b6b4578.html" target="_blank">
        <span class="sap-icon">&#xe1c3;</span>
      </a>
    </div>
    <div class="step-wrapper">
      <h2 class="cald-heading">{{ 'TableBuilderAspx_Step1Message' | translate }}</h2>
      <div class="row">
        <div class="col-6 select-table-wrapper">
          <cpq-select [(ngModel)]="model.tableName.id" id="selectTable"
            [type]="SelectType.Simple" [items]="tableNames"
            [label]="{key: 'TableBuilderAspx_Step1FromTable', placeholder: 'FormulaBuilder.StartTyping'}"
            (ngModelChange)="tableNameChanged($event)">
          </cpq-select>
        </div>
        <div class="col-6 flex">
          <button type="button" class="btn btn-secondary fiori3-btn-secondary no-label" id="previewTable"
          (click)="previewDataTable()">{{'TableBuilderAspx_Step1PreviewTableDataButton' | translate}}</button>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <cpq-select [(ngModel)]="model.returnType.id" id="selectReturnType"
            [type]="SelectType.Simple" [items]="returnTypes"
            [label]="{key: 'TableBuilderAspx_Step1ReturnLabel', placeholder: 'FormulaBuilder.StartTyping'}"
            (ngModelChange)="returnTypeChanged($event)">
          </cpq-select>
        </div>
        <div class="col-6"> </div>
      </div>
      <div class="row">
        <div class="col-4 mb-4">
          <cpq-select [(ngModel)]="model.columnName.id" id="selectColumn"
            [type]="SelectType.Simple" [items]="columnNames"
            [label]="{key: 'TableBuilderAspx_Step1FromColumnLabel', placeholder: 'FormulaBuilder.StartTyping'}"
            (ngModelChange)="columnNameChanged($event)">
          </cpq-select>
        </div>
        <div class="col-4">
          <cpq-select [(ngModel)]="model.columnType.id" id="selectColumnType"
            [type]="SelectType.Simple" [items]="columnTypes"
            [label]="{key: 'TableBuilderAspx_Step1ColumnTypeLabel', placeholder: 'FormulaBuilder.StartTyping'}"
            (ngModelChange)="columnTypeChanged($event)">
          </cpq-select>
        </div>
        <div class="col-4">
          <cpq-select [ngModel]="model.sortType && model.sortType.id" (ngModelChange)="model.sortType && model.sortType.id = $event" id="selectSort"
            [type]="SelectType.Simple" [items]="sortTypes"
            [label]="{key: 'TableBuilderAspx_Step1SortLabel', placeholder: 'FormulaBuilder.StartTyping'}"
            [setFirstOptionSelected]='true'>
          </cpq-select>
        </div>
      </div>
    </div>
    <div class="step-wrapper condition-section-wrapper page-content-wrapper">
      <h2 class="cald-heading">{{ 'TableBuilderAspx_Step2Message' | translate }}</h2>
      @for (condition of model.conditions; track condition; let i = $index) {
        <div class="row">
          <div class="col-3">
            @if (i==0) {
              <label>{{'TableBuilderAspx_Step2ConditionsHeaderColumnLabel' | translate}}</label>
            }
            <cpq-select [(ngModel)]="condition.columnName.id" id="selectConditionColumn"
              [type]="SelectType.Simple" [items]="columnNames"
              (ngModelChange)="conditionColumnNameChanged($event, condition)">
            </cpq-select>
          </div>
          <div class="col-3">
            @if (i==0) {
              <label>{{'TableBuilderAspx_Step2ConditionsHeaderColumnTypeLabel' | translate}}</label>
            }
            <cpq-select [(ngModel)]="condition.columnType.id" id="selectConditionColumnType"
              [type]="SelectType.Simple" [items]="columnTypes"
              (ngModelChange)="conditionColumnTypeChanged($event, condition)">
            </cpq-select>
          </div>
          <div class="col-3">
            @if (i==0 && condition.operations.length > 0) {
              <label>{{'TableBuilderAspx_Step2ConditionsHeaderOperatorLabel' | translate}}</label>
            }
            <cpq-select *any="condition.operations" id="selectConditionOperator"
              [(ngModel)]="condition.operation.id" [items]="condition.operations"
              (ngModelChange)="conditionOperationChanged($event, condition)">
            </cpq-select>
          </div>
          <div class="col-3">
            @if (i==0) {
              <label>{{'TableBuilderAspx_Step2ConditionsHeaderValueLabel' | translate}}</label>
            }
            <cpq-input [(ngModel)]="condition.value" id="insertConditionValue" [name]="'value'" [config]='data'></cpq-input>
          </div>
          <div class="remove-row-icon">
            @if (i > 0) {
              <span (click)="removeCondition(i)">
                <span class="sap-icon">&#xe03e;</span>
              </span>
            }
          </div>
        </div>
      }
      <div class="new-condition-button"> <a id="addCondition" (click)="addNewCondition()">{{'TableBuilderAspx_Step2ConditionsAddNewButtonText'| translate}}</a> </div>
    </div>
    <!-- End of Step 2 -->
    <!-- Step 3 -->
    <div class="step-wrapper">
      <div class="alert alert-info">
        <span class="sap-icon">&#xe202;</span>
        <div class="content">
          {{'FormulaBuilder_Table_Step3Message' | translate}}
        </div>
      </div>
      <div class="component-wrapper">
        <cpq-textarea #formulaTextAreaElement #formulaTextArea="ngModel" id="resultFormula"
          [control]="formulaTextArea" [name]="'formulaTextArea'" [(ngModel)]="formula"
        [label]="{key:'FormulaBuilder.ConditionFormula'}"></cpq-textarea>
        <div class="flex">
          <div class="flex">
            @if (syntaxCheckResponse) {
              <span class="parse-formula-message" id="syntaxCheckResponseMessage"
                [title]="syntaxCheckResponse.message">{{syntaxCheckResponse.message}}
              </span>
            }
          </div>
          <div>
            <button type="button" class="btn btn-secondary fiori3-btn-secondary" id="buildFormula"
              (click)="buildFormula()">{{'TableBuilderAspx_BuildFormulaLinkButtonText' | translate}}
            </button>
            <button type="button" class="btn btn-secondary fiori3-btn-secondary" id="testFormula"
              (click)="testFormula()">{{'TableBuilderAspx_TestFormulaLinkButtonText' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End of Step 3 -->
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" id="pushTagToFormula"
      (click)="pushTagToFormula()">{{'Admin.Msg.Insert' | translate}}
    </button>
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" id="cancel" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>